function FloatingSaveBar({ isChanged, submit, reset }) {
  return (
    isChanged && (
      <div className="sticky bottom-0 py-2 bg-gray-100 flex gap-2 rounded-lg my-4 justify-end px-4">
        <button className={ButtonClasses("red")} onClick={reset}>
          Revert
        </button>
        <button className={ButtonClasses("indigo")} onClick={submit}>
          Save
        </button>
      </div>
    )
  );
}
const ButtonClasses = (color) =>
  `rounded-md bg-${color}-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-xs hover:bg-${color}-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-${color}-600 dark:bg-${color}-500 dark:shadow-none dark:hover:bg-{color}-400 dark:focus-visible:outline-${color}-500`;

export default FloatingSaveBar;
